import domReady from 'domready';

import client from './client';

domReady(() => {
    client(window);
});
